export default "__VITE_ASSET__BnF3VRr7__"